import { useMemo } from 'react';
import useArrayArray from './array/useArray';
export function useArray(initial) {
    const [value, actions] = useArrayArray(initial);
    return useMemo(() => (Object.assign({ value }, actions)), [actions, value]);
}
export default useArray;
//# sourceMappingURL=useArray.js.map